import { render, staticRenderFns } from "./draggable_list.vue?vue&type=template&id=7142e9e3"
import script from "./draggable_list.vue?vue&type=script&lang=js"
export * from "./draggable_list.vue?vue&type=script&lang=js"
import style0 from "./draggable_list.vue?vue&type=style&index=0&id=7142e9e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports